export default __webpack_public_path__ + "881674d3a5af7b8ac574a26447835fa4.jpg";